"use client";

import { useState } from "react";

export function useEnquiryForm() {
  const [isOpen, setIsOpen] = useState(false);

  const openEnquiry = () => setIsOpen(true);
  const closeEnquiry = () => setIsOpen(false);

  return {
    isOpen,
    openEnquiry,
    closeEnquiry,
    setIsOpen,
  };
}

